<template>
  <div class="room-facility-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('room_facilities.title') }}</h2>
      <b-button variant="primary" @click="createRoomFacility">
        <i class="fas fa-plus mr-2"></i>{{ $t('room_facilities.create_button') }}
      </b-button>
    </div>
    <CrudTable :columns="fields" :data-sources="roomFacilities" :pagination="paginationInfo" :loader="isLoading"
      list-url="/room-facilities" @search="handleSearch" @filter="handleFilter" @refresh="fetchRoomFacilities" ref="action-table">
      <template #cell(room_type)="data">
        <div>{{ (data.item.room_type?.name || '-') + ' - ' + (data.item.room_type?.bed_type || '-') }}</div>
      </template>

      <template #cell(facility_name)="data">
        <div>{{ data.item.facility?.name || '-' }}</div>
      </template>
      <template #cell(actions)="data">
        <div class="d-flex gap-2">
          <b-button variant="outline-primary" size="sm" @click="editRoomFacility(data.item)">
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button variant="outline-danger" size="sm" @click="confirmDelete(data.item)">
            <i class="fas fa-trash"></i>
          </b-button>
        </div>
      </template>
    </CrudTable>
    <b-modal v-model="showDeleteModal" :title="$t('room_facilities.delete_modal_title')" @ok="handleDelete"
      ok-variant="danger">
      {{ $t('room_facilities.delete_modal_message') }}
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";

export default {
  name: "RoomFacilityList",
  components: {
    CrudTable,
  },
  data() {
    return {
      roomFacilities: [],
      isLoading: false,
      showDeleteModal: false,
      selectedRoomFacility: null,
      currentPage: 1,
      perPage: 10,
      sortBy: "created_at",
      sortDesc: true,
      filters: {
        search: "",
        status: null,
      },
      fields: [
        { key: "room_type", label: this.$t("room_facilities.table_header_room_type"), sortable: false },
        { key: "facility_name", label: this.$t("room_facilities.table_header_facility_name"), sortable: false },
        { key: "actions", label: this.$t("common.actions") },
      ],
      paginationInfo: {
        from: 0,
        to: 0,
        total: 0,
      },
    };
  },
  methods: {
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
      this.fetchRoomFacilities();
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
      this.fetchRoomFacilities();
    },
    createRoomFacility() {
      this.$router.push("/admin/room-facilities/create");
    },
    editRoomFacility(roomFacility) {
      this.$router.push(`/admin/room-facilities/${roomFacility.id}/edit`);
    },
    confirmDelete(roomFacility) {
      this.selectedRoomFacility = roomFacility;
      this.showDeleteModal = true;
    },
    async handleDelete() {
      try {
        await request({
          method: "delete",
          url: `/room-facilities/${this.selectedRoomFacility.id}`,
        });
        this.fetchRoomFacilities();
        this.$refs['action-table'].refreshTableData();
      } catch (error) {
        console.error("Error deleting room facility:", error);
      }
    },
    async fetchRoomFacilities() {
      try {
        this.isLoading = true;
        const response = await request({
          method: "get",
          url: "/room-facilities",
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            sort_by: this.sortBy,
            sort_desc: this.sortDesc,
            ...this.filters,
          },
        });
        if (response.data && response.data.data) {
          this.roomFacilities = response.data.data;
          if (response.data.meta) {
            this.paginationInfo = {
              from: response.data.meta.from || 0,
              to: response.data.meta.to || 0,
              total: response.data.meta.total || 0,
            };
          }
        } else {
          this.roomFacilities = [];
          this.paginationInfo = {
            from: 0,
            to: 0,
            total: 0,
          };
        }
      } catch (error) {
        console.error("Error fetching room facilities:", error);
        this.roomFacilities = [];
        this.paginationInfo = {
          from: 0,
          to: 0,
          total: 0,
        };
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchRoomFacilities();
  },
};
</script>

<style scoped>
.room-facility-list {
  padding: 20px;
}
</style>